import { Link } from "react-router-dom";
import { Youtube } from "lucide-react";
import { Logo } from "./Logo";
import { YOUTUBE_URL } from "../data/modules";

export const Header = () => (
  <header className="site-header" data-testid="site-header">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
      <Link to="/" data-testid="header-logo-link"><Logo /></Link>
      <nav className="flex items-center gap-1 sm:gap-6 text-[15px]">
        <Link to="/#modules" className="nav-link hidden sm:inline" data-testid="nav-modules-link">Modules</Link>
        <Link to="/#calculator" className="nav-link hidden sm:inline" data-testid="nav-calculator-link">Calculator</Link>
        <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="yt-btn" data-testid="header-youtube-link">
          <Youtube size={18} /> <span>Watch</span>
        </a>
      </nav>
    </div>
  </header>
);
